var App = App || {};

App.VcSubpageCards = (function ($) {
    "use strict";

    function init() {
        var $subpageCards = $("section.vc.vc-subpage-cards"),
            $cards = $subpageCards.find(".card");

        if ($subpageCards.length) {
            $cards.matchHeight(false);
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.VcSubpageCards.init();
});